import Logger from '../../logging/logger';
import { initGlobalAnalyticClickEvents } from './click-events';
import triggerEvent, { FormSubmitEvent, GAEventName } from './events';
import { initGlobalAnalyticEventHandler } from './global-event-handler';

export function initGoogleAnalyticHandlers(): void {
    if ( window.baseAnalyticEventParameters ) {
        Logger.info( 'Initialising analytis with base parameters', window.baseAnalyticEventParameters );
    }

    Logger.info( 'Initialising analytic click events' );

    initGlobalAnalyticClickEvents();

    Logger.info( 'Initialising single-click event handling' );

    initGlobalAnalyticEventHandler();

    initPWAEvents();
}

function initPWAEvents(): void {
    window.addEventListener( 'appinstalled', () => {
        triggerEvent<FormSubmitEvent>( GAEventName.FormSubmit, {
            'form_name': 'pwa_install_prompt',
        } );
    } );

    window.addEventListener( 'beforeinstallprompt', () => {
        triggerEvent<FormSubmitEvent>( GAEventName.FormSubmit, {
            'form_name': 'pwa_install_prompt',
        } );
    } );
}
